import { Result } from "antd";
import { DefaultButton } from "components/Shared/DefaultButton";
import { useIntl } from "react-intl";
import { Link, useSearchParams } from "react-router-dom";

export const NotFoundPage = () => {
  const [searchParams] = useSearchParams();
  const { formatMessage } = useIntl();
  const homeUrl = searchParams.get("homeUrl") || "/";

  return (
    <Result
      status="error"
      title={formatMessage({ id: "notFoundPage.title" })}
      subTitle={formatMessage({ id: "notFoundPage.subTitle" })}
      extra={
        <Link to={homeUrl}>
          <DefaultButton>{formatMessage({ id: "button.backHome" })}</DefaultButton>
        </Link>
      }
    />
  );
};
